import { ChangeEvent, Dispatch, SetStateAction } from 'react';
import MenuItem from '@mui/material/MenuItem';
import Quotefield from '../../../../../../pages/dashboard/tradedocuments/quotation/quotefield/quotefield';
import {
    medthodsOfDispatch,
    typesOfShipment
} from '../../../../../../utils/appconstants';
import PortsAutocomplete from '../../../../../autocompletewithapi/PortsAutocomplete';
import Customdatepicker from '../../../../../customdatepicker/customdatepicker';
import CustomTextField from '../../../../../CustomTextInput';
import NewCustomSelect from '../../../../../newcustomselect/newcustomselect';
import { SuitUIButton } from '../../../../../SuitUIButton';
import UploadLogo from '../../../common/UploadLogo';
import UploadStamp from '../../../common/UploadStamp';
import { CorporatePartner } from '../../../../../../interfaces/CorporatePartner';
import {
    PurchaseOrder,
    PurchaseOrderFormErrors
} from '../../../../../../interfaces/PurchaseOrder';
import { TransformedItems } from '../../../../../../pages/dashboard/tradedocuments/tradeDocumentTypes/CommercialTypes';

interface PurchaseOrderStepOneFormProps {
    updateField: (name: string, value: string | number) => void;
    payload: PurchaseOrder;
    corporatePartners: CorporatePartner[];
    loadingCorporatepartners: boolean;
    setShowAddPartner: Dispatch<SetStateAction<boolean>>;
    errors: PurchaseOrderFormErrors;
    quoteFields: TransformedItems[];
    updateQuoteField: (
        index: number,
        attributeName: keyof TransformedItems,
        attributeValue: TransformedItems[keyof TransformedItems]
    ) => void;
    removeQuoteField: (index: number) => void;
    addQuoteField: () => void;
    activeStep: number;
    setActiveStep: (step: number) => void;
}

const StepOne = ({
    updateField,
    payload,
    corporatePartners,
    loadingCorporatepartners,
    setShowAddPartner,
    errors,
    quoteFields,
    updateQuoteField,
    removeQuoteField,
    addQuoteField
}: PurchaseOrderStepOneFormProps) => {
    return (
        <div className='w-full flex flex-col gap-4'>
            <UploadLogo {...{ payload, updateField }} />

            <UploadStamp {...{ payload, updateField }} />
            <NewCustomSelect
                selectValue={payload.sellerId as unknown as string}
                required
                selectOptions={
                    corporatePartners as unknown as (
                        | string
                        | Record<string, unknown>
                    )[]
                }
                name={'sellerId'}
                updateField={(_, value) => {
                    updateField('sellerId', value);
                    updateField(
                        'sellerBank',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.bankName
                    );
                    updateField(
                        'sellerBankAccount',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.bankAccountNumber
                    );
                    updateField(
                        'sellerSwiftCode',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.swiftCode
                    );
                    updateField(
                        'sellerAddress',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.address
                    );
                    updateField(
                        'sellerName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.name
                    );
                }}
                label={'Invoice From'}
                selectOptionLabel='name'
                loading={loadingCorporatepartners}
                dropdownRender={() => {
                    return (
                        <div className='px-4 border-t border-appcolorgreyfaint'>
                            <p
                                className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                onClick={() => {
                                    setShowAddPartner(true);
                                }}
                            >
                                + Add a New Partner
                            </p>
                        </div>
                    );
                }}
            />

            <CustomTextField
                error={errors?.purchaseOrderNumber.length > 0}
                helperText={
                    errors?.purchaseOrderNumber.length > 0
                        ? errors?.purchaseOrderNumber
                        : undefined
                }
                required
                id='purchaseorder-purchaseOrderNumber'
                label='Purchase Order Number'
                name='purchaseOrderNumber'
                value={payload?.purchaseOrderNumber}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('purchaseOrderNumber', e.target.value);
                }}
            />

            <Customdatepicker
                value={payload?.documentDate || null}
                id='quotation-issuedDate'
                label='Date'
                name='issuedDate'
                updateField={updateField}
                error={errors?.documentDate.length > 0}
                helperText={
                    errors?.documentDate.length > 0
                        ? errors?.documentDate
                        : undefined
                }
            />

            <NewCustomSelect
                selectValue={payload.receiverId as unknown as string}
                required
                selectOptions={
                    corporatePartners as unknown as (
                        | string
                        | Record<string, unknown>
                    )[]
                }
                name={'receiverId'}
                updateField={(_, value) => {
                    updateField('receiverId', value);
                    updateField(
                        'receiverAddress',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.address
                    );
                    updateField(
                        'receiverBank',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.bankName
                    );
                    updateField(
                        'receiverBankAccount',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.bankAccountNumber
                    );
                    updateField(
                        'receiverSwiftCode',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.swiftCode
                    );
                    updateField(
                        'receiverName',
                        corporatePartners.filter(
                            (item: CorporatePartner) => item.id === value
                        )[0]?.name
                    );
                }}
                label={'Invoice  To'}
                selectOptionLabel='name'
                loading={loadingCorporatepartners}
                dropdownRender={() => {
                    return (
                        <div className='px-4 border-t border-appcolorgreyfaint'>
                            <p
                                className='px-4 py-2 cursor-pointer text-appcolorprimary'
                                onClick={() => {
                                    setShowAddPartner(true);
                                }}
                            >
                                + Add a New Partner
                            </p>
                        </div>
                    );
                }}
            />

            <CustomTextField
                error={errors?.supplierReference.length > 0}
                helperText={
                    errors?.supplierReference.length > 0
                        ? errors?.supplierReference
                        : undefined
                }
                required
                id='purchaseorder-supplierReference'
                label='Supplier Reference'
                name='supplierReference'
                value={payload?.supplierReference}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('supplierReference', e.target.value);
                }}
            />

            <CustomTextField
                error={errors?.shipperReference.length > 0}
                helperText={
                    errors?.shipperReference.length > 0
                        ? errors?.shipperReference
                        : undefined
                }
                required
                value={payload?.shipperReference}
                id='purchaseorder-shipperReference'
                label='Shipper Reference'
                name='shipperReference'
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('shipperReference', e.target.value);
                }}
            />

            <CustomTextField
                select
                error={errors?.methodOfDispatch.length > 0}
                helperText={
                    errors?.methodOfDispatch.length > 0
                        ? errors?.methodOfDispatch
                        : undefined
                }
                required
                id='purchaseorder-methodOfDispatch'
                label='Method of Dispatch'
                name='methodOfDispatch'
                value={payload?.methodOfDispatch}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('methodOfDispatch', e.target.value);
                }}
            >
                {medthodsOfDispatch.map((item, index) => (
                    <MenuItem
                        value={item}
                        key={`medthodsOfDispatch-${item}-${index}`}
                    >
                        {item}
                    </MenuItem>
                ))}
            </CustomTextField>

            <CustomTextField
                select
                error={errors?.typeOfShipment.length > 0}
                helperText={
                    errors?.typeOfShipment.length > 0
                        ? errors?.typeOfShipment
                        : undefined
                }
                required
                id='purchaseorder-typeOfShipment'
                label='Type of Shipment'
                name='typeOfShipment'
                value={payload?.typeOfShipment}
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('typeOfShipment', e.target.value);
                }}
            >
                {typesOfShipment.map((item, index) => (
                    <MenuItem
                        value={item}
                        key={`typesOfShipment-${item}-${index}`}
                    >
                        {item}
                    </MenuItem>
                ))}
            </CustomTextField>

            <PortsAutocomplete
                errorCondition={errors?.portOfLoadingId.length > 0}
                helperText={
                    errors?.portOfLoadingId.length > 0
                        ? errors?.portOfLoadingId
                        : undefined
                }
                id='quotation-portOfLoading'
                label='Port of Loading'
                name='portOfLoadingId'
                updateField={updateField}
                nameValue='portOfLoadingValue'
                value={payload.portOfLoadingValue}
            />

            <PortsAutocomplete
                errorCondition={errors?.portOfDischargeId.length > 0}
                helperText={
                    errors?.portOfDischargeId.length > 0
                        ? errors?.portOfDischargeId
                        : undefined
                }
                id='quotation-portOfDischargeId'
                label='Port of Discharge'
                name='portOfDischargeId'
                updateField={updateField}
                nameValue='portOfDischargeValue'
                value={payload.portOfDischargeValue}
            />

            <CustomTextField
                error={errors?.billOfLadingNumber.length > 0}
                helperText={
                    errors?.billOfLadingNumber?.length > 0
                        ? errors?.billOfLadingNumber
                        : undefined
                }
                value={payload?.billOfLadingNumber}
                required
                id='quotation-billOfLadingNumber'
                label='Bill of Lading Number'
                name='billOfLadingNumber'
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('billOfLadingNumber', e.target.value);
                }}
            />

            <CustomTextField
                error={errors?.salesContractNumber?.length > 0}
                helperText={
                    errors?.salesContractNumber?.length > 0
                        ? errors?.salesContractNumber
                        : undefined
                }
                value={payload?.salesContractNumber}
                required
                id='quotation-salesContractNumber'
                label='Sales Contract Number'
                name='salesContractNumber'
                onChange={(e: ChangeEvent<HTMLInputElement>) => {
                    updateField('salesContractNumber', e.target.value);
                }}
            />
            {quoteFields.map((item, index) => (
                <Quotefield
                    item={item}
                    key={item.id}
                    index={index}
                    id={item.id ?? ''}
                    updateQuoteField={updateQuoteField}
                    price={item.price ?? 0}
                    qty={item.qty ?? 0}
                    removeQuoteField={removeQuoteField}
                />
            ))}

            <SuitUIButton
                text='Add field'
                onClick={addQuoteField}
                invert
                fullWidth
                style='px-[0.92rem] border border-gray300 text-steelBlue font-medium text-sm leading-[20px] lg:border-none lg:text-appcolorprimary'
            />
        </div>
    );
};

export default StepOne;
